"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._InventoryOptionalFields = {
    type: "list",
    member: {
        shape: {
            type: "string"
        },
        locationName: "Field"
    }
};
//# sourceMappingURL=_InventoryOptionalFields.js.map